// extracted by mini-css-extract-plugin
export default {"root":"styles_root__zI8Ue","guide":"styles_guide__A3abK","header":"styles_header__zhs8H","buttonWrapper":"styles_buttonWrapper__X0l0E","divider":"styles_divider__8IsZA"};